import type { ReactNode } from "react";
import { cn } from "@client/lib/cn";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  action?: ReactNode;
  as?: "h1" | "h2";
  className?: string;
}

export function SectionHeading({ eyebrow, title, description, action, as = "h2", className }: SectionHeadingProps) {
  const Heading = as;
  return (
    <div className={cn("flex flex-col gap-4 md:flex-row md:items-end md:justify-between", className)}>
      <div className="max-w-2xl">
        <p className="font-mono text-xs tracking-widest text-foreground-muted uppercase">{eyebrow}</p>
        <Heading
          className={cn(
            "text-gradient mt-3 leading-tight font-semibold tracking-tight",
            as === "h1" ? "text-3xl md:text-5xl" : "text-2xl md:text-4xl",
          )}
        >
          {title}
        </Heading>
        {description && <p className="mt-3 leading-relaxed text-foreground-muted">{description}</p>}
      </div>
      {action}
    </div>
  );
}
